<template>
  <div class="c-table-container c-table-container__nested">
    <table class="c-table">
      <caption
        class="tw:sr-only"
        data-testid="table-caption"
      >
        {{
          $t("outreach_contact_lists_table.caption")
        }}
      </caption>
      <thead>
        <tr>
          <th
            :aria-sort="ariaSort('name')"
            data-testid="column-header"
            role="columnheader"
            scope="col"
            style="width: 190px"
          >
            <TableSortOrder
              v-model="filters.sortOrder"
              :label="$t('global.name')"
              sort-by="name"
            >
              <template #labelStart>
                <slot name="nameHeader" />
              </template>
            </TableSortOrder>
          </th>
          <th
            :aria-sort="ariaSort('contactListsContactsCount')"
            data-testid="column-header"
            role="columnheader"
            scope="col"
            style="width: 90px"
          >
            <TableSortOrder
              v-model="filters.sortOrder"
              :label="$t('outreach_contact_lists_table.contacts_title')"
              sort-by="contactListsContactsCount"
            />
          </th>
          <th
            :aria-sort="ariaSort('mediaReleasesContactListsCount')"
            data-testid="column-header"
            role="columnheader"
            scope="col"
            style="width: 100px"
          >
            <TableSortOrder
              v-model="filters.sortOrder"
              :label="$t('outreach_contact_lists_table.media_releases_title')"
              sort-by="mediaReleasesContactListsCount"
            />
          </th>
          <th
            :aria-sort="ariaSort('pitchesContactListsCount')"
            data-testid="column-header"
            role="columnheader"
            scope="col"
            style="width: 80px"
          >
            <TableSortOrder
              v-model="filters.sortOrder"
              :label="$t('outreach_contact_lists_table.pitches_title')"
              sort-by="pitchesContactListsCount"
            />
          </th>
          <th
            data-testid="column-header"
            role="columnheader"
            scope="col"
            style="width: 70px"
          >
            <div class="row justify-center">
              {{ $t("outreach_contact_lists_table.created_by_title") }}
            </div>
          </th>
          <th
            data-testid="column-header"
            role="columnheader"
            scope="col"
            style="width: 95px"
          >
            <div class="row justify-center">
              {{ $t("outreach_contact_lists_table.tags") }}
            </div>
          </th>
          <template v-if="!compact">
            <th
              data-testid="column-header"
              role="columnheader"
              scope="col"
              style="width: 95px"
            >
              <div class="row justify-center">
                {{ $t("outreach_contact_lists_table.updated_by_title") }}
              </div>
            </th>
            <th
              :aria-sort="ariaSort('updatedAt')"
              data-testid="column-header"
              role="columnheader"
              scope="col"
              style="width: 110px"
            >
              <TableSortOrder
                v-model="filters.sortOrder"
                :label="$t('outreach_contact_lists_table.last_updated_title')"
                sort-by="updatedAt"
              />
            </th>
            <th
              data-testid="column-header"
              role="columnheader"
              scope="col"
              style="width: 100px"
            >
              <div class="row justify-center">
                {{ $t("outreach_contact_lists_table.actions_title") }}
              </div>
            </th>
          </template>
        </tr>
        <TableLoadingIndicator v-if="loading" />
      </thead>
      <tbody>
        <OutreachContactListRow
          v-for="contactList in contactLists"
          :key="contactList.id"
          :compact="compact"
          :contact-list="contactList"
          :is-selected="selectedIds.includes(contactList.id)"
          @action="$emit($event, contactList)"
          @update:is-selected="$emit('update:selected-ids', $event)"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import TableLoadingIndicator from "shared/components/table/TableLoadingIndicator.vue";
import TableSortOrder from "shared/components/table/TableSortOrder";

import OutreachContactListRow from "./OutreachContactListRow.vue";

export default {
  name: "OutreachContactListsTable",
  components: {
    OutreachContactListRow,
    TableLoadingIndicator,
    TableSortOrder,
  },
  props: {
    compact: {
      type: Boolean,
    },
    contactLists: {
      type: Array,
      required: true,
    },
    rowHover: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    selectedIds: {
      type: Array,
      required: true,
    },
    paginationTarget: {
      type: String,
      default: "organisation-footer",
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:selected-ids", "update:sort-order"],
  watch: {
    filters: {
      deep: true,
      handler(newValue) {
        this.$emit("update:sort-order", newValue.sortOrder);
      },
    },
  },
  methods: {
    ariaSort(sortBy) {
      const { sortOrder } = this.filters;

      if (sortOrder?.sortBy !== sortBy || !sortOrder.sortDirection) {
        return undefined;
      }

      return sortOrder.sortDirection === "asc" ? "ascending" : "descending";
    },
  },
};
</script>

<style>
.c-table__outreach-contact-lists {
  table-layout: fixed;
  width: 100%;
}
</style>
